<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <layouts></layouts>
        <sidebar-menu></sidebar-menu>
        <div class="page-wrapper">
            <div class="content">
                <div class="row mb-4">
                    <div class="d-flex justify-content-between">

                        <h6 class="fw-bold">Dashboard</h6>

                        <div class="d-flex align-items-center ms-auto gap-2">
                            <div class="form-group">
                                <div class="input-groupicon" style="z-index: 100;">
                                    <datepicker v-model="periode" class="picker" :editable="true"
                                        :clearable="false" @update:modelValue="index" />
                                    <a class="addonset">
                                        <i class='bx bx-calendar'></i>
                                    </a>
                                </div>
                            </div>                            
                            
                        </div>
                    </div>
                </div>
                <div class="row">
                    <!-- chart waiting Approval -->
                    
                    <div class="col-12 col-lg-12">
                        <div class="row ">

                            <div class="col" style="flex: 0 0 20%; max-width: 20%">
                                <div class="card text-black p-3 rounded-3" style="border: 1px solid #09B67D; background-color: #09B67D; color: white;">

                                     <!-- Loading Spinner -->
                                    <div v-if="isLoadingBranch" class="d-flex justify-content-center align-items-center" style="height: 50px;">
                                        <div class="spinner-border text-light" role="status" style="width: 1.5rem; height: 1.5rem;">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                    
                                    <div class="" v-else>
                                        <h4 class="mb-1 fw-bold" style="color: white;">{{ this.waiting_approval.jumlah }}</h4>
                                        
                                    </div>
                                    <small @click="goToApproval()" style="color: white; cursor:pointer;">Waiting Approval</small>
                                    
                                </div>
                            </div>
                            <div class="col" style="flex: 0 0 20%; max-width: 20%">
                                <div class="card text-black p-3 rounded-3" style="border: 1px solid #09B67D;">

                                    <!-- Loading Spinner -->
                                    <div v-if="isLoadingBranch" class="d-flex justify-content-center align-items-center" style="height: 50px;">
                                        <div class="spinner-border " role="status" style="width: 1.5rem; height: 1.5rem; color: #09B67D;">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>

                                    <div class="" v-else>

                                        <div class="d-flex justify-content-between align-items-start">
                                            <h4 class="mb-1 text-black fw-bold">{{ this.companyList.jumlah }}</h4>
                                            <img src="@/assets/img/buliding.png" alt="icon" style="width: 20px; height: 20px; ">
                                        </div>
                                    </div>
                                    <small @click="goToBranch()" style="cursor:pointer;">All Branch</small>
                                </div>
                            </div>
                            <div class="col" style="flex: 0 0 20%; max-width: 20%">
                                <div class="card text-black p-3 rounded-3" style="border: 1px solid #09B67D;">
                                    <!-- Loading Spinner -->
                                    <div v-if="isLoadingBranch" class="d-flex justify-content-center align-items-center" style="height: 50px;">
                                        <div class="spinner-border " role="status" style="width: 1.5rem; height: 1.5rem; color: #09B67D;">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>

                                    <div class="" v-else>

                                        <div class="d-flex justify-content-between align-items-start">
                                            <h4 class="mb-1 text-black fw-bold">{{ this.companyEmployee.jumlah }}</h4>
                                            <img src="@/assets/img/profile-2user.png" alt="icon" style="width: 20px; height: 20px; ">
                                        </div>
                                    </div>

                                    <small @click="goToEmployee()" style="cursor:pointer;">Total Employee</small>
                                </div>
                            </div>
                            <div class="col" style="flex: 0 0 20%; max-width: 20%">
                                <div class="card text-black p-3 rounded-3" style="border: 1px solid #09B67D;">

                                    <!-- Loading Spinner -->
                                    <div v-if="isLoadingBranch" class="d-flex justify-content-center align-items-center" style="height: 50px;">
                                        <div class="spinner-border " role="status" style="width: 1.5rem; height: 1.5rem; color: #09B67D;">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>

                                    <div class="" v-else>

                                        <div class="d-flex justify-content-between align-items-start">  
                                            <h4 class="mb-1 text-black fw-bold">{{ this.absensiList.outside_visit }}</h4>
                                            <img src="@/assets/img/buildings.png" alt="icon" style="width: 20px; height: 20px; ">
                                        </div>
                                    </div>

                                    <small @click="goToAttendance()" style="cursor:pointer;">Outside Visit</small>
                                </div>
                            </div>

                            <div class="col" style="flex: 0 0 20%; max-width: 20%">
                                <div class="card text-black p-3 rounded-3" style="border: 1px solid #09B67D;">

                                    <!-- Loading Spinner -->
                                    <div v-if="isLoadingBranch" class="d-flex justify-content-center align-items-center" style="height: 50px;">
                                        <div class="spinner-border " role="status" style="width: 1.5rem; height: 1.5rem; color: #09B67D;">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>

                                    <div class="" v-else>
                                        <div class="d-flex justify-content-between align-items-start">   
                                            <h4 class="mb-1 text-black fw-bold">{{ this.absensiList.annual_leave }}</h4>
                                            <img src="@/assets/img/export.png" alt="icon" style="width: 20px; height: 20px; ">
                                        </div>
                                    </div>
                                    <small @click="goToAttendance()" style="cursor:pointer;">Annual Leave</small>
                                </div>
                            </div>

                            <!-- second row -->
                            <div class="col" style="flex: 0 0 20%; max-width: 20%">
                                <div class="card text-black p-3 rounded-3" style="border: 1px solid #09B67D;">

                                    <!-- Loading Spinner -->
                                    <div v-if="isLoadingBranch" class="d-flex justify-content-center align-items-center" style="height: 50px;">
                                        <div class="spinner-border " role="status" style="width: 1.5rem; height: 1.5rem; color: #09B67D;">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>

                                    <div class="" v-else>

                                        <div class="d-flex justify-content-between align-items-start">  
                                            <h4 class="mb-1 text-black fw-bold">{{ this.absensiList.present }}</h4>
                                            <img src="@/assets/img/user-tick.png" alt="icon" style="width: 20px; height: 20px; ">
                                        </div>
                                    </div>

                                    <small @click="goToAttendance()" style="cursor:pointer;">Present</small>
                                </div>
                            </div>
                            <div class="col" style="flex: 0 0 20%; max-width: 20%">
                                <div class="card text-black p-3 rounded-3" style="border: 1px solid #09B67D;">

                                    <!-- Loading Spinner -->
                                    <div v-if="isLoadingBranch" class="d-flex justify-content-center align-items-center" style="height: 50px;">
                                        <div class="spinner-border " role="status" style="width: 1.5rem; height: 1.5rem; color: #09B67D;">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>

                                    <div class="" v-else>
                                        <div class="d-flex justify-content-between align-items-start">  
                                            <h4 class="mb-1 text-black fw-bold">{{ this.absensiList.late }}</h4>
                                            <img src="@/assets/img/user-remove.png" alt="icon" style="width: 20px; height: 20px; ">
                                        </div>
                                    </div>
                                    <small @click="goToAttendance()" style="cursor:pointer;">Late</small>
                                </div>
                            </div>
                            <div class="col" style="flex: 0 0 20%; max-width: 20%">
                                <div class="card text-black p-3 rounded-3" style="border: 1px solid #09B67D;">

                                    <!-- Loading Spinner -->
                                    <div v-if="isLoadingBranch" class="d-flex justify-content-center align-items-center" style="height: 50px;">
                                        <div class="spinner-border " role="status" style="width: 1.5rem; height: 1.5rem; color: #09B67D;">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>

                                    <div class="" v-else>
                                        <div class="d-flex justify-content-between align-items-start">  
                                            <h4 class="mb-1 text-black fw-bold">{{ this.absensiList.leave }}</h4>
                                            <img src="@/assets/img/document-previous.png" alt="icon" style="width: 20px; height: 20px; ">
                                        </div>
                                    </div>
                                    <small @click="goToAttendance()" style="cursor:pointer;">Leave</small>
                                </div>
                            </div>
                            <div class="col" style="flex: 0 0 20%; max-width: 20%">
                                <div class="card text-black p-3 rounded-3" style="border: 1px solid #09B67D;">

                                    <!-- Loading Spinner -->
                                    <div v-if="isLoadingBranch" class="d-flex justify-content-center align-items-center" style="height: 50px;">
                                        <div class="spinner-border " role="status" style="width: 1.5rem; height: 1.5rem; color: #09B67D;">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>

                                    <div class="" v-else>
                                        <div class="d-flex justify-content-between align-items-start">  
                                            <h4 class="mb-1 text-black fw-bold">{{ this.absensiList.absent }}</h4>
                                            <img src="@/assets/img/document-previous.png" alt="icon" style="width: 20px; height: 20px; ">
                                        </div>
                                    </div>
                                    <small @click="goToAttendance()" style="cursor:pointer;">Absent</small>
                                </div>
                            </div>
                            

                            <!-- Other Cards -->
                            <!-- <div class="col-md-3" v-for="(item, index) in stats" :key="index">
                                <div class="card text-black p-3 rounded-3" style="border: 1px solid #09B67D;" >
                                    <h4 class="mb-1 text-black fw-bold">{{ item.value }}</h4>
                                    <small>{{ item.label }}</small>
                                </div>
                            </div> -->
                        </div>


                    </div>
                    

                    <div class="col-12">
                        <div class="row">

                            <div class="col-md-4">
                                <div class="card p-3" style=" border: 1px solid #09B67D; height: 248px;">
                                    <p class="fw-bold">Job Level</p>

                                    <!-- Loading Spinner -->
                                    <div v-if="isLoadingBranch" class="d-flex justify-content-center align-items-center" style="height: 50px;">
                                        <div class="spinner-border " role="status" style="width: 1.5rem; height: 1.5rem; color: #09B67D;">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>

                                    <div class="" v-else>

                                        <b-progress class="mt-1 rounded-5" style="height: 25px; background-color: #f4f4f4;">
                                            <!-- <b-progress-bar
                                                v-for="job in jobLevelsWithPercentage"
                                                :key="job.name"
                                                :value="job.percentage"
                                                :style="{ backgroundColor: job.color }"
                                            ></b-progress-bar> -->
                                            <b-progress-bar
                                                v-for="job in jobLevelsWithPercentage"
                                                :key="job.name"
                                                :value="job.percentage"
                                                :style="{ backgroundColor: job.color }"
                                            ></b-progress-bar>
                                        </b-progress>
                                        <div class="d-flex justify-content-between ">
                                            <p>0%</p>
                                            <p>100%</p>
                                        </div>
                                        <div class="">
                                            <div v-for="job in jobLevelsWithPercentage" :key="job.name" class="d-flex justify-content-between">
                                                <span>
                                                <span class="legend-box" :style="{ backgroundColor: job.color }"></span>
                                                {{ job.name }}
                                                </span>
                                                <span>{{ job.count }}    ({{ isNaN(job.percentage) ? '0.00' : Number(job.percentage).toFixed(2) }}%)</span>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                                
                            </div>
                            <div class="col-md-4">
                                <div class="card p-3" style=" border: 1px solid #09B67D;">
                                    <p class="fw-bold">Length of Service</p>
                                    
                                    <!-- Loading Spinner -->
                                    <div v-if="isLoadingBranch" class="d-flex justify-content-center align-items-center" style="height: 50px;">
                                        <div class="spinner-border " role="status" style="width: 1.5rem; height: 1.5rem; color: #09B67D;">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>

                                    <div class="" v-else>
                                        <div class="chartjs-wrapper-demo" style="margin-bottom: 25px;">
                                            <vue3-chart-js
                                                :key="idWorkPeriodChart"
                                                class="chartjs-chart"
                                                v-bind="{ ...verticalchartJs }"
                                            ></vue3-chart-js>
                                        </div>
                                    </div>
                                    
                                </div>
                                
                            </div>
                            <div class="col-md-4">
                                <div class="card p-3" style=" border: 1px solid #09B67D; height: 248px;">
                                    <p class="fw-bold">Employment Status</p>

                                    <!-- Loading Spinner -->
                                    <div v-if="isLoadingBranch" class="d-flex justify-content-center align-items-center" style="height: 50px;">
                                        <div class="spinner-border " role="status" style="width: 1.5rem; height: 1.5rem; color: #09B67D;">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>

                                    <div class="" v-else>

                                        <b-progress class="mt-1 rounded-5" style="height: 25px; background-color: #f4f4f4;">
                                            
                                            <!-- <b-progress-bar
                                                    v-for="employee in employmentStatus"
                                                    :key="employee.name"
                                                    :value="employee.percentage"
                                                    :style="{ backgroundColor: employee.color }"
                                            ></b-progress-bar> -->
                                            <b-progress-bar
                                                v-for="employee in employmentStatus"
                                                :key="employee.name"
                                                :value="employee.percentage"
                                                :style="{ backgroundColor: employee.color }"
                                            ></b-progress-bar>
                                        </b-progress>
                                        <div class="d-flex justify-content-between ">
                                            <p>0%</p>
                                            <p>100%</p>
                                        </div>
                                        <div class="">
                                            <div v-for="employee in employmentStatus" :key="employee.name" class="d-flex justify-content-between">
                                                <span>
                                                <span class="legend-box" :style="{ backgroundColor: employee.color }"></span>
                                                {{ employee.name }}
                                                </span>
                                                <span>{{ employee.count }} ({{ employee.percentage.toFixed(2) }}%)</span>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                
                            </div>
                        </div>
                        
                    </div>

                    <div class="col-12 ">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="card p-3 rounded-3" style="border: 1px solid #09B67D;">
                                    <p class="fw-bold">Performance Management</p>

                                    <!-- Loading Spinner -->
                                    <div v-if="isLoadingBranch" class="d-flex justify-content-center align-items-center" style="height: 50px;">
                                        <div class="spinner-border " role="status" style="width: 1.5rem; height: 1.5rem; color: #09B67D;">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>

                                    <div class="" v-else>

                                        <div class="chartjs-wrapper-demo" style="margin-bottom: 10px;">
                                            <vue3-chart-js
                                                :key="idPerformanceChart"
                                                class="chartjs-chart"
                                                v-bind="{ ...linechartJs }"
                                            ></vue3-chart-js>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <!-- Gender Diversity -->
                            <div class="col-md-2">
                                <div class="card p-3" style=" border: 1px solid #09B67D;">
                                    <p>Gender Diversity</p>
                                    
                                    <!-- Loading Spinner -->
                                    <div v-if="isLoadingBranch" class="d-flex justify-content-center align-items-center" style="height: 50px;">
                                        <div class="spinner-border " role="status" style="width: 1.5rem; height: 1.5rem; color: #09B67D;">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>

                                    <div class="" v-else>

                                        <div class="chartjs-wrapper-demo " style="margin-bottom: 10px;">
                                            <vue3-chart-js 
                                                
                                                :key="idGenderChart"
                                                class="chartjs-chart"
                                                v-bind="{ ...genderChart }"
                                            ></vue3-chart-js>
                                        </div>
                                        <!-- <div class="" style=" width: 100%;">
                                            <canvas ref="genderChart"></canvas>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card p-3 rounded-3" style="border: 1px solid #09B67D;">
                                    <p class="fw-bold">Headcount & Turnover</p> 
                                    
                                    <!-- Loading Spinner -->
                                    <div v-if="isLoadingBranch" class="d-flex justify-content-center align-items-center" style="height: 50px;">
                                        <div class="spinner-border " role="status" style="width: 1.5rem; height: 1.5rem; color: #09B67D;">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>

                                    <div class="" v-else>

                                        <div class="chartjs-wrapper-demo" style="width: 100%; height: 160px;">
                                            <vue3-chart-js
                                                :key="idTurnOverChart"
                                                class="chartjs-chart"
                                                v-bind="{ ...piechartJs }"
                                            ></vue3-chart-js>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                 

                </div>



            </div>


            
        </div>
        
    </div>

</template>

<style >
.apexcharts-legend.apx-legend-position-bottom.apexcharts-align-right {

    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    /* background-color: red; */
}

.btn-datefilter {
    background-color: #09B67D !important;
    border-radius: 15px !important;
    color: white !important;
}

.legend-box {
    display: inline-block;
    width: 12px;  /* Adjust size as needed */
    height: 12px; /* Adjust size as needed */
    margin-right: 8px;
    border-radius: 2px; /* Optional: Make it slightly rounded */
}

.dropdown-menu {
  display: block;
  position: absolute;
}

</style>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import { base_url, timeout, AlertPopup2, goPage, appendForm, selectedBranch } from "@/assets/js/function";
import { onMounted, ref, watch } from "vue";
import Chart from "chart.js/auto";
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";
import { verticalchartJs, piechartTurnover, linechartPerformance, genderChart } from "./data";
import { DatePicker } from "ant-design-vue";
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(ChartDataLabels);

export default {
    components: {
        Vue3ChartJs,
    },
    data() {
        return {
            isRefresh: 'true',
            verticalchartJs: verticalchartJs,
            piechartJs: piechartTurnover,
            linechartJs: linechartPerformance,
            genderChart: genderChart,

            idGenderChart: 0,
            idWorkPeriodChart: 0,
            idTurnOverChart: 0,
            idPerformanceChart: 0,

            donutAreaChart: {
                donutchart: {
                    chart: {
                        id: "vuechart-example",
                    },

                    chart: {
                        type: 'pie',
                        height: 350,
                        stacked: true,
                        toolbar: {
                            show: false,
                        },
                        dataLabels: {
                            enabled: true,
                        },
                    },
                    legend: {
                        position: 'bottom',
                        horizontalAlign: 'right',

                    },
                    labels: ['Present', 'Late', 'Absent', 'Annual Leave', 'Leave'],
                    colors: ['#08B67E', '#FFC42F', '#FA547C', '#5271FF', '#ACCE25'],
                },
                series: [],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }

                }],
            },
            data: [],
            columns: [
                {
                    title: "No",
                    dataIndex: "Sno",
                    sorter: {
                        compare: (a, b) => {
                            a = a.Sno.toLowerCase();
                            b = b.Sno.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Form",
                    dataIndex: "judul",
                    key: "id",
                    sorter: {
                        compare: (a, b) => {
                            a = a.judul.toLowerCase();
                            b = b.judul.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
            ],
            columns2: [],
            data2: [],
            absensiList: [],
            companyList: [],
            companyEmployee: [],
            genderList: [],
            turn_over: [],
            performance: [],
            work_period: [],
            job_level: [],
            employee_status: [],
            waiting_approval: [],
            branchList: [],
            periode: new Date(),
            jobLevels: [
                { name: "Direktur", count: 0, color: "#B3D8FF" }, // Light blue
                { name: "Manager", count: 0, color: "#FFD24C" }, // Yellow
                { name: "Staff", count: 0, color: "#09B67D" }, // Green
                { name: "Supervisor", count: 0, color: "#FF9500" }, // Orange
            ],
            employment: [
                { name: "Permanent", count: 0, color: "#09B67D" }, // Green
                { name: "Contract", count: 0, color: "#FFD24C" }, // Yellow
                { name: "Probation", count: 0, color: "#B3D8FF" }, // Light blue
                { name: "Internship", count: 0, color: "#FF9500" }, // Orange
            ],
            config: "",
            api: "",
            showChart: false,
            companyselected: "",
            filter: 0,
            token: "",
            value: 45,
            max: 100,

            // for spinner loading
            isLoadingBranch: false,
        };
    },
    watch: {
        job_level: {
            handler() {
                this.mapJobLevels(); // Auto-update when API data changes
            },
            deep: true,
            immediate: true
        },
        employee_status: {
            handler() {
                this.mapJobLevels(); // Auto-update when API data changes
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        totalCount() {
            return this.jobLevels.reduce((sum, job) => sum + job.count, 0);
        },
        totalCountEmployment() {
            if (!this.employee_status) return 0; // Prevent undefined errors
            return (
                (this.employee_status.permanent || 0) +
                (this.employee_status.contract || 0) +
                (this.employee_status.probation || 0) +
                (this.employee_status.internship || 0)
            );
        },
        jobLevelsWithPercentage() {
            if (this.totalCount === 0) return []; // Prevent division by zero

                return [
                {
                    name: "Direktur",
                    count: this.job_level.direktur || 0,
                    percentage: Number(this.job_level.percent_direktur) || 0,
                    color: "#B3D8FF"
                },
                {
                    name: "Manager",
                    count: this.job_level.manager || 0,
                    percentage: Number(this.job_level.percent_manager) || 0,
                    color: "#FFD24C"
                },
                {
                    name: "Supervisor",
                    count: this.job_level.supervisor || 0,
                    percentage: Number(this.job_level.percent_supervisor) || 0,
                    color: "#09B67D"
                },
                {
                    name: "Staff",
                    count: this.job_level.staff || 0,
                    percentage: Number(this.job_level.percent_staff) || 0,
                    color: "#FF9500"
                },
                {
                    name: "Others",
                    count: this.job_level.others || 0,
                    percentage: Number(this.job_level.percent_others) || 0,
                    color: "#A0A0A0"
                }
            ];
        },
        employmentStatus() {
             if (this.totalCountEmployment === 0) return [];

            return [
                {
                name: "Permanent",
                count: this.employee_status.permanent || 0,
                percentage: Number(this.employee_status.percent_permanent) || 0,
                color: "#09B67D"
                },
                {
                name: "Contract",
                count: this.employee_status.contract || 0,
                percentage: Number(this.employee_status.percent_contract) || 0,
                color: "#FFD24C"
                },
                {
                name: "Probation",
                count: this.employee_status.probation || 0,
                percentage: Number(this.employee_status.percent_probation) || 0,
                color: "#B3D8FF"
                },
                {
                name: "Internship",
                count: this.employee_status.internship || 0,
                percentage: Number(this.employee_status.percent_internship) || 0,
                color: "#FF9500"
                },
                {
                name: "Others",
                count: this.employee_status.others || 0,
                percentage: Number(this.employee_status.percent_others) || 0,
                color: "#A0A0A0"
                }
            ];
        },
    },
    mounted() {
        this.mapJobLevels();

        watch(selectedBranch, () => {
            this.index()
        }, { immediate: true })
    },
    methods: {
        randomValue() {
            this.value = Math.random() * this.max
        },
        goToApproval() {
            goPage('approval')
        },
        goToBranch() {
            goPage('location')
        },
        goToEmployee() {
            goPage('employee')
        },
        goToAttendance() {
            goPage('historyattendance')
        },
        updateGenderChart() {
            this.genderChart.data.datasets[0].data = [
                this.genderList.male || 0,
                this.genderList.female || 0
            ];
        },
        mapJobLevels() {
            if (this.job_level) {
                this.jobLevels = [
                    { name: "Direktur", count: this.job_level.direktur || 0, percentage: this.job_level.percent_direktur || 0, color: "#B3D8FF"},
                    { name: "Manager", count: this.job_level.manager || 0, percentage: this.job_level.percent_manager || 0, color: "#FFD24C" },
                    { name: "Supervisor", count: this.job_level.supervisor || 0, percentage: this.job_level.percent_supervisor || 0, color: "#09B67D" },
                    { name: "Staff", count: this.job_level.staff || 0, percentage: this.job_level.percent_staff || 0, color: "#FF9500"}
                ];
            }
        },
        mapEmployeeStatus() {
            if (this.employee_status) {
                this.employement = [
                    { name: "Permanent", count: this.employee_status.permanent || 0, percentage: this.employee_status.percent_permanent || 0, color: "#09B67D" }, // Green
                    { name: "Contract", count: this.employee_status.contract || 0, percentage: this.employee_status.percent_contract || 0, color: "#FFD24C" }, // Yellow
                    { name: "Probation", count: this.employee_status.probation || 0, percentage: this.employee_status.percent_probation || 0, color: "#B3D8FF" }, // Light blue
                    { name: "Internship", count: this.employee_status.internship || 0, percentage: this.employee_status.percent_internship || 0, color: "#FF9500" }, // Orange
                        
                ];
            }
        },
        formatDateLocal(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-based
            const day = String(date.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        },
        async index() {
            const formData = new FormData();
            appendForm(formData);
            formData.append("periode", this.formatDateLocal(this.periode));
            // for (let [key, value] of formData.entries()) {
            //     console.log(key, value);
            // }

            // for loading spinner
            this.isLoadingBranch = true;

            const api = base_url + 'v3/dashboard/index';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;
            // console.log("INI DATANYA >>>", data);
            if (data.status) {
                const response = data.data

                this.waiting_approval = response.data_waiting_approval;
                this.absensiList = response.data_absensi;
                this.companyEmployee = response.data_employee;
                this.companyList = response.data_branch;
                this.genderList = response.data_gender;
                this.turn_over = response.data_employee_turn_over;
                this.performance = response.data_performance;
                this.job_level = response.data_job_level;
                this.work_period = response.data_employee_work_periode;
                this.employee_status = response.data_employee_status;

                // console.log('jumlah waiting',this.waiting_approval.jumlah)

                if (this.genderList) {
                    this.genderChart.data.datasets[0].data = [
                        this.genderList.male || 0,
                        this.genderList.female || 0,
                    ];
                    this.genderChart.data.labels = ["Male", "Female"];
                }
                if (this.turn_over) {
                    this.piechartJs.data.datasets[0].data = [
                        this.turn_over.in || 0,
                        this.turn_over.out || 0,
                    ];
                    this.piechartJs.data.labels = ["In", "Out"];
                }
                if (this.performance && this.linechartJs) {
                    this.linechartJs.data.datasets[0].data = this.performance.present || Array(12).fill(0);
                    this.linechartJs.data.datasets[1].data = this.performance.late || Array(12).fill(0);
                    this.linechartJs.data.labels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];;
                }
                if (this.work_period) {
                    this.verticalchartJs.data.datasets[0].data = [
                        this.work_period["<1y"] || 0,
                        this.work_period["1-2y"] || 0,
                        this.work_period["3-5y"] || 0,
                        this.work_period[">6y"] || 0  
                    ];
                    this.verticalchartJs.data.labels = ['< 3 Yr', '1 - 3 Yr', '3 - 5 Yr', '5 - 10 Yr'];
                }
                this.idGenderChart++;
                this.idWorkPeriodChart++;
                this.idTurnOverChart++;
                this.idPerformanceChart++;
            } else {
                AlertPopup2("error", "", "Dashboard fetch error", true, 1500);
            }

            this.isLoadingBranch = false;
        },

        // index() {
        //     ShowLoading();
        //     let formData = new FormData();
        //     const currentDate = new Date();
        //     const formattedDate = currentDate.toISOString().slice(0, 10);

        //     formData.append("periode", formattedDate);

        //     if (process.env.NODE_ENV === "development") {
        //         this.api = base_url + 'dashboard_absensi';
        //     } else {
        //         this.api = base_url + 'dashboard_absensi';
        //     }
        //     axios
        //         .post(this.api, formData, this.config)
        //         .then((response) => {
        //             if (response.data.status == true) {
        //                 this.showChart = false;
        //                 if (response.data.data.hadir == 0 && response.data.data.terlambat == 0 && response.data.data.absen == 0) {
        //                     this.showChart = false;
        //                 } else {
        //                     this.donutAreaChart.series = [response.data.data.hadir, response.data.data.terlambat, response.data.data.absen]
        //                     this.showChart = true;
        //                 }

        //                 CloseLoading();
        //             }
        //             if (response.data.status == false) {
        //                 AlertPopup("error", "", response.data.message, 1500, false);
        //             }
        //         })
        //         .catch((error) => {
        //             ErrorConnectionTimeOut(error);
        //         });

        // },
        
        // dashboard_index() {
        //     ShowLoading();
        //     let formData = new FormData();
        //     const currentDate = new Date();
        //     var dateObj = new Date(this.periode);

        //     var year = dateObj.getFullYear();
        //     var month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
        //     var day = ('0' + dateObj.getDate()).slice(-2);
        //     var formattedDate = `${year}-${month}-${day}`;
        //     formData.append("periode", formattedDate);
        //     if (!this.filter) {
        //         const savedBranch = localStorage.getItem("selectedBranch");
        //         this.filter = savedBranch !== null ? savedBranch : 0;
        //     }
        //     if( this.filter == 0){
        //         formData.append("filter", '');
        //     }else {
        //         formData.append("filter", this.filter);
        //     }

        //     if (process.env.NODE_ENV === "development") {
        //         this.api = base_url + 'dashboard_index2';
        //     } else {
        //         this.api = base_url + 'dashboard_index2';
        //     }
        //     axios
        //         .post(this.api, formData, this.config)
        //         .then((response) => {
        //             // console.log(response.data)
        //             if (response.data.status == true) {
        //                 // localStorage.setItem('nama_user', response.data.data.fullname);
        //                 // localStorage.setItem('tipe_user', response.data.data.tipe);
        //                 this.absensiList = response.data.data.data_dashboard.absensi;
        //                 this.companyList = response.data.data.data_dashboard.company;
        //                 this.genderList = response.data.data.data_dashboard.jenis_kelamin;
        //                 this.turn_over = response.data.data.data_dashboard.turn_over;
        //                 this.performance = response.data.data.data_dashboard.performance;
        //                 this.job_level = response.data.data.data_dashboard.job_level;
        //                 this.work_period = response.data.data.data_dashboard.work_period;
        //                 this.employee_status = response.data.data.data_dashboard.employee_status;

        //                 if (this.genderList) {
        //                     this.genderChart.data.datasets[0].data = [
        //                         this.genderList.male || 0,
        //                         this.genderList.female || 0,
                                
        //                     ];
        //                     this.genderChart.data.labels = ["Male", "Female"];
        //                 }

        //                 // turn over
        //                 if (this.turn_over) {
        //                     this.piechartJs.data.datasets[0].data = [
        //                         this.turn_over.in || 0,
        //                         this.turn_over.out || 0,
        //                     ];
        //                     this.piechartJs.data.labels = ["In", "Out"];
        //                 }

        //                 // performance
        //                 if (this.performance && this.linechartJs) {
        //                     this.linechartJs.data.datasets[0].data = this.performance.present || Array(12).fill(0);
        //                     this.linechartJs.data.datasets[1].data = this.performance.late || Array(12).fill(0);
        //                     this.linechartJs.data.labels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];;
        //                 }
        //                 if (this.work_period) {
        //                     this.verticalchartJs.data.datasets[0].data = [
        //                         this.work_period["<1y"] || 0,
        //                         this.work_period["1-2y"] || 0,
        //                         this.work_period["3-5y"] || 0,
        //                         this.work_period[">6y"] || 0  
        //                     ];
        //                     this.verticalchartJs.data.labels = ['< 3 Yr', '1 - 3 Yr', '3 - 5 Yr', '5 - 10 Yr'];
        //                 }
        //                 this.idGenderChart++;
        //                 this.idWorkPeriodChart++;
        //                 this.idTurnOverChart++;
        //                 this.idPerformanceChart++;
        //                 CloseLoading();
        //             }

        //             if (response.data.status == false) {
        //                 AlertPopup("error", "", response.data.message, 1500, false);

        //             }
        //         })
        //         .catch((error) => {
        //             ErrorConnectionTimeOut(error);
        //         });

        
    },
    created() {
        this.token = Cookies.get("token_refresh");
        this.config = {
            headers: { Authorization: `Bearer ` + this.token },
            timeout: 30000,
        }
        
        const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

        //Update local and shared state
        this.filter = branch;
        selectedBranch.value = branch;

        localStorage.setItem('actionState', 'view')

        this.index();


       
    }
};
</script>
